module.exports = __webpack_public_path__ + "img/42c795a.png";